import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=498a32a0&scoped=true&"
import script from "./pagination.ts?vue&type=script&lang=ts&"
export * from "./pagination.ts?vue&type=script&lang=ts&"
import style0 from "./pagination.scss?vue&type=style&index=0&id=498a32a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a32a0",
  null
  
)

export default component.exports